import { BillingType } from './BillingType';

export default BillingType;
